import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './DashboardIcons';
import { useLiveCountdown } from '../../lib/matchCountdown';

export const formatMatchDate = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat('ar-SA-u-ca-gregory', { weekday: 'long', day: 'numeric', month: 'long' }).format(d);
};

export const formatMatchTime = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat('ar-SA-u-ca-gregory', { hour: 'numeric', minute: '2-digit' }).format(d);
};

const ScheduleCountdown = ({ item }) => {
  const text = useLiveCountdown(item.date_raw, item.status);
  if (!text) return null;
  return <div className="text-[11px] font-semibold text-teal-700" data-testid="schedule-item-countdown">{text}</div>;
};

export const SectionCard = ({ title, icon, action, children, testId }) => (
  <div className="rounded-xl border border-slate-200 bg-white" data-testid={testId}>
    <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3">
      <div className="flex items-center gap-2">
        <span className="text-[#16233b]"><Icon name={icon} className="w-[18px] h-[18px]" /></span>
        <h3 className="text-sm font-bold text-slate-800">{title}</h3>
      </div>
      {action}
    </div>
    <div className="p-5">{children}</div>
  </div>
);

export const EmptyState = ({ icon = 'inbox', text, testId }) => (
  <div className="flex flex-col items-center justify-center py-6 text-center" data-testid={testId}>
    <span className="mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-400">
      <Icon name={icon} className="w-5 h-5" />
    </span>
    <p className="text-sm text-slate-500">{text}</p>
  </div>
);

// جدول القادم — يعرض المباريات الفعلية فقط، بنية قابلة لإضافة أنواع أحداث مستقبلاً (تدريبات، اجتماعات)
export const TodaySchedule = ({ upcomingMatches }) => {
  const items = (upcomingMatches || []).map((m) => ({
    id: m.id,
    type: 'match',
    title: `${m.home_team_name || m.home_team || 'فريق'} × ${m.away_team_name || m.away_team || 'فريق'}`,
    subtitle: [m.tournament_name, m.category_name].filter(Boolean).join(' • '),
    date: formatMatchDate(m.match_date),
    time: formatMatchTime(m.match_date),
    date_raw: m.match_date,
    status: m.status,
  }));

  return (
    <SectionCard
      title="القادم"
      icon="calendar"
      testId="today-schedule"
      action={<Link to="/matches" className="text-xs font-semibold text-teal-700 hover:text-teal-800" data-testid="schedule-view-all">عرض المباريات</Link>}
    >
      {items.length === 0 ? (
        <EmptyState icon="calendar" text="لا توجد مباريات أو أحداث قادمة مجدولة حالياً" testId="schedule-empty" />
      ) : (
        <ul className="space-y-3">
          {items.map((item) => (
            <li key={item.id} className="flex items-center gap-3 rounded-lg border border-slate-100 bg-slate-50/60 px-3 py-2.5" data-testid="schedule-item">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white border border-slate-200 text-[#16233b]">
                <Icon name="trophy" className="w-4 h-4" />
              </span>
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-semibold text-slate-800">{item.title}</div>
                {item.subtitle && <div className="truncate text-xs text-slate-500">{item.subtitle}</div>}
              </div>
              <div className="text-left shrink-0">
                {item.date && <div className="text-xs font-medium text-slate-600">{item.date}</div>}
                {item.time && <div className="text-xs text-slate-400">{item.time}</div>}
                <ScheduleCountdown item={item} />
              </div>
            </li>
          ))}
        </ul>
      )}
    </SectionCard>
  );
};

export default TodaySchedule;
